import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { FormControl, InputGroup, FormGroup, ControlLabel, Glyphicon, Overlay, Button, Form } from 'react-bootstrap'
import { MonthView, Footer } from 'react-date-picker'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select';
import moment from 'moment'
import 'react-date-picker/index.css'
import './date-picker.css'
var th = require('moment/locale/th')
const CustomPopover = React.createClass({
  render() {
    return (
      <div
        style={{
          ...this.props.style,
          position: 'absolute',
          backgroundColor: '#EEE',
          boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
          border: '1px solid #CCC',
          borderRadius: 3,
          marginLeft: 0,
          marginTop: 0,
          padding: 10,
          zIndex: 1070
        }}
      >
        {this.props.children}
      </div>
    );
  },
});

class DatePicker extends Component {
  constructor(...props) {
    super(...props)
    let value = (typeof this.props.value !== 'undefined') ? this.props.value : ''

    this.state = {
      focus: false,
      open: false,
      text: value,
      popPlacement: 'top',
      windowInnerHeight: 0,
      selectOption: ''
    }
    this.updatePopPlacement = this.updatePopPlacement.bind(this)

  }

  updatePopPlacement() {
    this.setState({ windowInnerHeight: window.innerHeight })

  }

  componentWillMount() {
    this.updatePopPlacement()

  }

  componentWillReceiveProps(newProps){
    if (newProps.value!==this.props.value)
      this.setState({text:newProps.value})
  }

  componentDidMount() {
    window.addEventListener("resize", this.updatePopPlacement)
    const MONTH_VIEW_HEIGHT = 368
    this.setState({
      popPlacement:
        ReactDOM.findDOMNode(this).getBoundingClientRect().bottom + MONTH_VIEW_HEIGHT > this.state.windowInnerHeight
          // ReactDOM.findDOMNode(this).getBoundingClientRect().bottom + MONTH_VIEW_HEIGHT > document.body.scrollHeight
          ? 'top'
          : 'bottom'
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePopPlacement);
  }

  onToggle(toggle) {
    this.setState({ open: toggle })
  }

  onFocus() {
    // console.log('onFocus')
    this.setState({ focus: true, open: true })
  }

  onBlur() {
    this.setState({ focus: false })
  }

  onClick() {
    //console.log('onClick')
    if(!this.props.disabled)
      this.setState({ open: !this.state.open })
  }

  onHide() {
    //console.log('onHide')
    this.setState({ open: this.state.focus })
  }

  onFooterCancel(){
    this.setState({open:false})
  }

  onFooterTodayClick(){
    //this.onAddingDateInputText('20/04/2562')
    //this.props.onChange('20/04/2562', moment())
    const dateString = moment().format('DD/MM/YYYY')
    this.onMonthViewChange(dateString,{dateMoment:moment()})
  }

  onSelectOption(e) {
    let {selectOption} = this.state
    selectOption = e.value
    this.setState({selectOption:selectOption,open:false})
    let fromMoment = moment().subtract(7, 'days')
    let toMoment = moment()
    if (e.value==='last-7-days') { // last-7-days
      fromMoment = moment().subtract(7, 'days')
      toMoment = moment()
    } else if (e.value==='last-30-days') { // last-30-days
      fromMoment = moment().subtract(30, 'days')
      toMoment = moment()
    } else if (e.value==='last-365-days') { // last-365-days
      fromMoment = moment().subtract(365, 'days')
      toMoment = moment()
    } else if (e.value==='today') { // today
      fromMoment = moment()
      toMoment = moment()
    } else if (e.value==='this-week') { // this-week
      fromMoment = moment().day(1)
      toMoment = moment().day(7)
    } else if (e.value==='this-month') { // this-month
      fromMoment = moment().startOf('month')
      toMoment = moment().endOf('month')
    } else if (e.value==='this-quarter') { // this-quarter
      fromMoment = moment().startOf('quarter')
      toMoment = moment().endOf('quarter')
    } else if (e.value==='this-year') { // this-year
      fromMoment = moment().startOf('year')
      toMoment = moment().endOf('year')
    } else if (e.value==='yesterday') { // yesterday
      fromMoment = moment().subtract(1, 'days').startOf('day')
      toMoment = moment().subtract(1, 'days').endOf('day')
    } else if (e.value==='last-week') { // last-week
      fromMoment = moment().subtract(1, 'weeks').startOf('week')
      toMoment = moment().subtract(1, 'weeks').endOf('week')
    } else if (e.value==='last-month') { // last-month
      fromMoment = moment().subtract(1, 'months').startOf('month')
      toMoment = moment().subtract(1, 'months').endOf('month')
    } else if (e.value==='last-quarter') { // last-quarter
      fromMoment = moment().subtract(1, 'quarters').startOf('quarter')
      toMoment = moment().subtract(1, 'quarters').endOf('quarter')
    } else if (e.value==='last-year') { // last-year
      fromMoment = moment().subtract(1, 'years').startOf('year')
      toMoment = moment().subtract(1, 'years').endOf('year')
    }  
    
    let fromDateString = fromMoment.format('DD/MM/YYYY')
    let toDateString = toMoment.format('DD/MM/YYYY')

    if (typeof this.props.buddhistEra !== 'undefined' && fromDateString !== null && fromDateString !== '') {
      let res = fromDateString.split("/");
      if (res.length >= 3)
        fromDateString = res[0] + '/' + res[1] + '/' + (res[2] * 1 + 543)
    }
    if (typeof this.props.buddhistEra !== 'undefined' && toDateString !== null && toDateString !== '') {
      let res = toDateString.split("/");
      if (res.length >= 3)
      toDateString = res[0] + '/' + res[1] + '/' + (res[2] * 1 + 543)
    }
    this.props.onRangeChange(fromDateString,toDateString,{from:fromMoment,to:toMoment})
  }

  renderFooter(showFooter) {
    if (showFooter) {
      return (<Footer todayButton={true} clearButton={true} />)
    }
    else {
      // return ('')
      if(this.props.onRangeChange!==undefined){
        return this.renderFooterRange()
      }else{
        return (<Footer todayButtonText={'เลือกวันนี้'} clearButtonText={'ยกเลิก'} />)
      }
    }
  }

  renderFooterRange(){
    let options = [{label:'7 วันล่าสุด',value:'last-7-days'},{label:'30 วันล่าสุด',value:'last-30-days'},
      {label:'365 วันล่าสุด',value:'last-365-days'},{label:'',value:'-',disabled:true},
      {label:'วันนี้',value:'today'},{label:'สัปดาห์นี้',value:'this-week'},
      {label:'เดือนนี้',value:'this-month'},{label:'Quarter นี้',value:'this-quarter'},
      {label:'ปีนี้',value:'this-year'},{label:'',value:'-',disabled:true},
      {label:'เมื่อวานนี้',value:'yesterday'},{label:'อาทิตย์ก่อน',value:'last-week'},
      {label:'เดือนก่อน',value:'last-month'},{label:'Quarter ก่อน',value:'last-quarter'},
      {label:'ปีก่อน',value:'last-year'}]
      let {selectOption} = this.state
      return (<Footer todayButtonText={'เลือกวันนี้'} clearButtonText={'ยกเลิก'} renderChildren={()=>{
        return (
          <div style={{display:'inline-flex'}}>
            <Select 
              clearable={false}
              name='form-field-name'
              placeholder='--- เลือก ---'
              style={{width:'150px'}}
              options={options} 
              value={selectOption}
              onChange={this.onSelectOption.bind(this)}
            /> 
            &nbsp;
            <Button onClick={this.onFooterTodayClick.bind(this)}><FontAwesome name='clock-o'/> วันนี้</Button>
            &nbsp;
            <Button onClick={this.onFooterCancel.bind(this)}><FontAwesome name='close'/> </Button>
          </div>
        )
      }} />)
  }

  onMonthViewChange(dateString, { dateMoment, timestamp }) {
    // console.log('dateMoment', dateMoment)
    if (typeof this.props.buddhistEra !== 'undefined' && dateString !== null && dateString !== '') {
      let res = dateString.split("/");
      if (res.length >= 3)
        dateString = res[0] + '/' + res[1] + '/' + (res[2] * 1 + 543)

    }
    this.setState({ text: dateString, open: false })
    // console.log('date:' + dateString)
    
    this.props.onChange(dateString, dateMoment)
  }

  //http://www.codetukyang.com/html/technic/filedatas/datepicker_buddhist_year/index.html
  renderMontView() {
    const {showFooter} = this.props
    // let value = (typeof this.props.value !== 'undefined') ? this.props.value : this.state.text
    let value = this.state.text
    if (typeof this.props.buddhistEra !== 'undefined' && value !== null && value !== '' && value !== undefined) {
      let res = value.split("/");
      if (res.length >= 3)
        value = res[0] + '/' + res[1] + '/' + (res[2] * 1 - 543)

    }
    return (

      <MonthView
        value={this.state.text}
        weekNumbers={false}
        locale="th"
        defaultDate={value}
        dateFormat="DD/MM/YYYY"
        weekStartDay={0}
        footer={showFooter}
        onChange={this.onMonthViewChange.bind(this)}
      >
        {this.renderFooter()}
      </MonthView>
    )
  }

  renderCalendarIcon() {
    if (typeof this.props.showIcon !== 'undefined' && !this.props.showIcon)
      return ('')
    return (
      <InputGroup.Addon className='border-none text-md' onClick={this.onClick.bind(this)} style={{pointerEvents:(this.props.disabledCalendarIcon?'none':'unset'),backgroundColor:(this.props.disabledCalendarIcon?'#f9f9f9':'#fff')}}>
        <Glyphicon glyph="calendar" />
      </InputGroup.Addon>
    )
  }

  onAddingDateInputText(dateInputText) {
    if ('DD'.length === dateInputText.length || 'DD/MM'.length === dateInputText.length) {
      this.setState({ text: dateInputText.concat('/') })
      return
    }
    if ('DD/MM/YYYY'.length > dateInputText.length) {
      this.setState({ text: dateInputText, open: false })
      return
    }
    if ('DD/MM/YYYY'.length === dateInputText.length) {
      const cYear = dateInputText.slice(dateInputText.lastIndexOf('/') + 1) * 1 - 543
      const newDate = dateInputText.slice(0, dateInputText.lastIndexOf('/') + 1).concat(cYear)
      const dateMoment = moment(newDate, 'DD/MM/YYYY')
      const dateArr = dateInputText.split('/')

      if (
        (dateArr.length > 0 && dateArr.some((val) => val === '')) ||
        (dateArr.length > 0 && dateArr.some((val) => isNaN(val)))
      ) {
        this.setState({ text: '' })
        return
      }
      if (dateMoment.isValid()) {
        // console.log('date is valid ', newDate)
        this.setState({ text: dateInputText, open: true })
        
        this.props.onTextChange(dateInputText, dateMoment)
        return
      }
    }
  }

  onTextDateChange(e) {
    const dateInputText = e.target.value
    this.onAddingDateInputText(dateInputText)
    // this.props.onDateValueChange(this.state.text)
  }

  dateInputValidate() {
    const dateInputText = this.state.text
    if (!dateInputText) return null
    const dateArr = dateInputText.split('/')
    if (dateArr.length===3) 
      return null
    else {  
      let dateM = (dateArr[2]-543)+'-'+dateArr[1]+'-'+dateArr[0]
      if (!moment(dateM).isValid()) { 
        return 'error' 
      }
    } 

    // if (!moment(dateInputText, 'DD').isValid()) { 
    //   return 'error' 
    // }
    // if (!moment(dateInputText, 'DD/MM').isValid()) { 
    //   return 'error' 
    // }
    
    if (dateInputText.length === 'DD/MM/YYYY'.length) {
      const cYear = dateInputText.slice(dateInputText.lastIndexOf('/') + 1) * 1 - 543
      const newDate = dateInputText.slice(0, dateInputText.lastIndexOf('/') + 1).concat(cYear)
      if (dateArr.some((val) => isNaN(val))) return 'error'
      if (!moment(newDate, 'DD/MM/YYYY').isValid())
        return 'error'
    }
    return null
  }

  onDateInputTextKeyDown(e) {
    const dateInputText = e.target.value
    if (e.key === 'Backspace') {
      this.setState({ text: dateInputText.slice(0, dateInputText.length - 1) })
      // this.props.onDateValueChange(this.state.text)
      return
    }
    if (isNaN(e.key)) return
  }

  renderDateControl() {
    let {isFormG} = this.props
    return (
      <Form style={this.props.style}>
        {isFormG
        ?
        this.renderContainerDatePicker()
        :
        this.renderNoFormGContainerDatePicker()}
      </Form>
    )  
  }

  renderDatePicker() {
    let {disabled,none,inputG,height}  = this.props
    let value = this.state.text // (typeof this.props.value !== 'undefined') ? this.props.value : this.state.text
    return( 
            <InputGroup style={{display:inputG,height:height}}>
              <FormControl ref='target' type="text"
                style={{ maxWidth: this.props.maxWidth, borderRadius: this.props.borderRadius, display:(none ? 'none' : '') }} // borderRadius: (this.props.showIcon === false ? '4px' : '0')
                className='date-picker'
                disabled={disabled}
                placeholder={this.props.placeholder}
                value={value}
                onFocus={this.onFocus.bind(this)}
                onBlur={this.onBlur.bind(this)}
                onKeyDown={this.onDateInputTextKeyDown.bind(this)}
                onChange={this.onTextDateChange.bind(this)}
                autoComplete={'off'}
              />
              {this.renderCalendarIcon()}
            </InputGroup>
    )
  }

  renderContainerDatePicker() {
    let {formG,inline}  = this.props
    let cLabel = '';

    if (typeof this.props.label !== 'undefined')
      cLabel = (<ControlLabel style={{ marginRight: '10px' }}>{this.props.label}</ControlLabel>)

    return(
          <FormGroup controlId="formInlineStart" validationState={this.dateInputValidate()} style={{display:formG,marginBottom:(inline?'0':'')}}>
            {cLabel}
            {this.renderDatePicker()}
          </FormGroup>
    )
  }

  renderNoFormGContainerDatePicker() {
    let {formG,inline}  = this.props
    let cLabel = '';

    if (typeof this.props.label !== 'undefined')
      cLabel = (<ControlLabel style={{ marginRight: '10px' }}>{this.props.label}</ControlLabel>)

    return(
          <div style={{display:formG,marginBottom:(inline?'0':'')}}>
            {cLabel}
            {this.renderDatePicker()}
          </div>
    )
  }

  render() {
    let placement = 'top'
    if (typeof this.props.popPlacement !== 'undefined')
      placement = this.props.popPlacement
    else
      placement = this.state.popPlacement

    let style = { position: 'relative' }
    if (typeof this.props.style !== 'undefined') {
      style = Object.assign(style, this.props.style)
    }


    return (
      <div
        style={style}
        ref={(ele) => { this.parentDiv = ele }}
        className={this.props.wSelect?'w-select xxx':'xxx'}
      >
        {this.renderDateControl()}

        <Overlay
          style={{ display: 'inline' }}
          show={this.state.open}
          onHide={this.onHide.bind(this)}
          placement={placement}
          rootClose
          target={() => ReactDOM.findDOMNode(this.refs.target)}
        >
          <CustomPopover >
            {this.renderMontView()}
          </CustomPopover>
        </Overlay>
      </div>
    )
  }


}


DatePicker.defaultProps = {
  disabled:false,
  disabledCalendarIcon:false,
  none:false,
  maxWidth:'100%', // maxWidth:'120px',
  borderRadius:'',
  formG:'inline-block',
  inputG:'inline-table',
  height:'auto',
  wSelect:false,
  showFooter:false,  
  onChange:()=>{},  
  onTextChange:()=>{},
  inline:true,
  isFormG:true
}

export default DatePicker



// WEBPACK FOOTER //
// ./src/component/element/DatePicker.js